import React, { useEffect, useState } from 'react';

import { useFrequentPassageRequests } from '../../../../hooks/api/frequent-passage-requests/useFrequentPassageRequests';
import { FrequentPassageRequest } from '../../../../hooks/api/utils/types';
import { useEvent } from '../../../../providers/event';
import { getFrequentPassageRequests } from '../../../../services/api/frequentPassageRequests';
import BasicInput from '../../../forms/fields/BasicInput';
import TextField from '../../../forms/standard-fields/TextField';
import { RedeemFrequentPassageRequestButton } from '@shared/frequent-passage-requests/components/RedeemFrequentPassageRequestButton';
import FrequentPassageRequestDetails from './FrequentPassageRequestDetails';

export default function FrequentPassageVoucherSearch() {
  const event = useEvent();
  const [barcode, setBarcode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [frequentPassageRequest, setFrequentPassageRequest] = useState<null | undefined | FrequentPassageRequest>(
    undefined
  );

  useEffect(() => {
    if (barcode.length === 0 && frequentPassageRequest) {
      setFrequentPassageRequest(undefined);
    }

    if (barcode.length) {
      setIsLoading(true);
      getFrequentPassageRequests(event!.id, { 'filter[barcode]': barcode })
        .then(
          (response) => {
            setFrequentPassageRequest(response.data[0] ?? null);
          },
          () => setFrequentPassageRequest(null)
        )
        .finally(() => setIsLoading(false));
    }
  }, [barcode]);

  return (
    <>
      <div className="m-portlet__body">
        <TextField
          label="Voucher barcode"
          value={barcode}
          onChange={setBarcode}
          name="barcode"
          style={{ maxWidth: '15rem' }}
          icon={'fa fa-barcode'}
        />
        {isLoading && <div className="m-loader m-loader--brand m-loader--lg" />}

        {!isLoading && frequentPassageRequest === null && (
          <div className="m-alert m-alert--outline alert alert-danger" role="alert">
            No voucher found with this barcode
          </div>
        )}

        {frequentPassageRequest && (
          <>
            <FrequentPassageRequestDetails frequentPassageRequest={frequentPassageRequest} />
          </>
        )}
      </div>
    </>
  );
}
